(function () {
  function setRem() {
    const doc = document.documentElement
    const width = doc.getBoundingClientRect().width
    if (width > 750) {
      doc.style.fontSize = '100px'
    } else {
      doc.style.fontSize = width / 10 + 'px'  // match klakna.sbs: 390→39px, 375→37.5px
    }
  }
  setRem()
  window.addEventListener('resize', setRem)
})()
